import React from "react";
import { Button, TextField } from "@material-ui/core";
import { MerchantsState } from "../../states/MerchantsState";
import { CustomTable } from "../../components/custom-table/CustomTable";
import { Subscription } from 'rxjs';
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import Media from "react-media";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { IMerchantsDto } from "../../models/MerchantsDto";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import Select from "../../components/select/Select";
import { MposLoader } from "../../components/loader/MposLoader";
import "./Merchants.scss";

export class Merchants extends React.Component<any, MerchantsState> {
  private statusTypes = ['', "ASSEGNATA", "NON ASSEGNATA"];
  private tableHeaderTitle = ['ID PUNTO VENDITA', 'AMMINISTRATORE PV', 'NOME APP', 'STATO', 'P.IVA',];
  private data = [];
  private textFieldRef: React.RefObject<HTMLInputElement>;
  private getMerchantsSubscription: Subscription | null = null;

  constructor(props: any) {
    super(props);

    this.state = {
      selectedStatus: null,
      filteredData: this.data,
      merchantsList: [],
      showLoader: false,
      buttonEnabled: true,
      pointOfSale: '',
      valueVatNumber: '',
      resultFilter: [],
      buttonDisabled: true,
    };

    this.textFieldRef = React.createRef();
    this.handleVatNumberOnChanges = this.handleVatNumberOnChanges.bind(this);
    this.handlePointOfSalesOnChanges = this.handlePointOfSalesOnChanges.bind(this);
    this.filterMerchants = this.filterMerchants.bind(this);
    this.handleRefined = this.handleRefined.bind(this);
  }

  componentDidMount(): void {
    this.textFieldRef.current?.focus();

    this.setState({
      showLoader: true,
    });

    this.getMerchantsSubscription = MposWebPortalApi.getInstance().getMerchants().subscribe((merchantsDto: IMerchantsDto) => {
      const merchants = merchantsDto !== null && merchantsDto.merchants !== null ? merchantsDto.merchants! : [];
      const merchantsRefined = this.handleRefined(merchants);
      this.setState({
        merchantsList: merchantsRefined,
        showLoader: false,
      });
    }, (error) => {
      this.setState({
        merchantsList: [],
        showLoader: false,
      });
    });

    GoogleTagManagerService.getInstance().pushPageEvent(this.props.location.pathname, "Cerca i tuoi merchant", {});
  }

  componentWillUnmount() {
    if (this.getMerchantsSubscription != null) {
      this.getMerchantsSubscription.unsubscribe();
    }
  }

  private static renderDesktopHeader(): JSX.Element {
    return <HeaderDesktop showBack={false} showLogout={true} showTitle={false} selectedElement={5} title={"Merchants"} />;
  }

  private static renderMobileHeader(): JSX.Element {
    return <HeaderMobile showBack={true} showLogout={true} showTitle={true} title={"Merchants"} />;
  }

  private handleRefined(values: any) {
    return values.map((value: any) => ({
      merchantId: value.merchantId,
      merchant: value.merchant,
      appName: value.appName,
      appStatus: value.appStatus,
      pIva: value.pIva,
      terminalInfo: value.terminalInfo,
    }))
  };

  private filterMerchants(): void {
    this.setState({ showLoader: true });

    const payload = {
      merchantId: this.state.pointOfSale,
      piva: this.state.valueVatNumber,
      state: this.state.selectedStatus,
      numElements: 999,
      numPage: 1,
      appId: null
    }

    MposWebPortalApi
      .getInstance()
      .searchMerchant(payload)
      .subscribe((response) => {
        if (response.merchants === null || response.merchants === undefined) {
          this.setState({
            merchantsList: []
          });
        } else {
          const refined = this.handleRefined(response.merchants);
          this.setState({
            merchantsList: refined
          });
        }
        this.setState({
          showLoader: false
        });
      },
        (error) => {
          this.setState({
            merchantsList: [],
            showLoader: false
          });
        });
  };

  private handleFieldValidation() {
    const { pointOfSale, valueVatNumber, selectedStatus } = this.state;

    if (pointOfSale !== '' || valueVatNumber !== '' || selectedStatus !== '') {
      this.setState({ buttonDisabled: false });
    } else {
      this.setState({ buttonDisabled: true });
    }
    if (pointOfSale === '' || valueVatNumber === '' || selectedStatus === '') {
      this.filterMerchants()
    }
  }

  private handleVatNumberOnChanges(event: any) {
    const newVatNumebr = event.target.value;
    this.setState({ valueVatNumber: newVatNumebr }, () => {
      // Controllo se entrambi i campi di ricerca sono vuoti
      if (this.state.valueVatNumber === '' && newVatNumebr === '') {
        const merchantsList = this.state.merchantsList || [];
        this.setState({
          resultFilter: [],
          merchantsList: merchantsList,
        });
      }
    });
  }

  private handlePointOfSalesOnChanges(event: any) {
    const newPointOfSales = event.target.value;
    this.setState({ pointOfSale: newPointOfSales }, () => {
      if (this.state.pointOfSale === '' && newPointOfSales === '') {
        const merchantsList = this.state.merchantsList || [];
        this.setState({
          resultFilter: [],
          merchantsList: merchantsList,
        });
      }
    });
  }

  render() {

    const { pointOfSale, valueVatNumber, selectedStatus } = this.state;
    const isSearchEnabled = pointOfSale !== '' || valueVatNumber !== '' || selectedStatus !== '';

    return (
      <>
        {
          // @ts-ignore
          <MposLoader show={this.state.showLoader} />
        }
        <div id="main-container-merchants">
          <Media query="(max-width: 1064px)" render={() => Merchants.renderMobileHeader()} />
          <Media query="(min-width: 1065px)" render={() => Merchants.renderDesktopHeader()} />
          <div className="merchant-container">
            <p className="merchant-title">Punti vendita abilitati</p>
            <div className="merchant-filter-container">
              <div className="merchant-filter-field">
                <TextField
                  id="merchant-field-vat-number"
                  label="P.IVA"
                  value={this.state.valueVatNumber}
                  onBlur={() => this.handleFieldValidation()}
                  onChange={this.handleVatNumberOnChanges}
                />
              </div>
              <div className="merchant-filter-field">
                <TextField
                  id="merchant-field-sale-point"
                  label="Punto vendita"
                  value={this.state.pointOfSale}
                  onChange={this.handlePointOfSalesOnChanges}
                  onBlur={() => this.handleFieldValidation()}
                />
              </div>
              <div className="merchant-filter-field">
                <Select
                  label="Stato"
                  value={this.state.selectedStatus}
                  volumeList={this.statusTypes}
                  setNewValue={(value: string) => {
                    this.setState({
                      selectedStatus: value
                    }, () => {
                      this.handleFieldValidation();
                    });
                  }}
                />
              </div>
              <div className="merchant-filter-field">
                <Button
                  id="merchant-search-button"
                  disabled={this.state.buttonDisabled}
                  type="submit"
                  onClick={() => {
                    if (isSearchEnabled) {
                      this.filterMerchants();
                    }
                  }}
                >
                  CERCA
                </Button>
              </div>
            </div>
            <div className="merchant-table-container">
              <CustomTable
                data={this.state.merchantsList}
                rowsPerPage={10}
                isCollapsable
                collapseLabel="Elenco TID"
                headerLabels={this.tableHeaderTitle}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
